export const API_SPEC_URL = "https://spec.api.lanepatrol.com/?api=external";
export const GOOGLE_API_KEY = "AIzaSyBaPvYBj9Vgk-YBut8OjdVX06aVqbO-zBU";
